import qs from 'query-string';
import { pushDataSignup } from 'lib/tracking';

export default {
  components: {
    'account-login-form': () =>
      import('../account-login-form/account-login-form.vue'),
    'account-register-form': () =>
      import('../account-register-form/account-register-form.vue'),
    'account-recover-form': () =>
      import('../account-recover-form/account-recover-form.vue'),
    'account-recover-form-alt': () =>
      import('../account-recover-alt/account-recover-form-alt.vue'),
    'account-reset-form': () =>
      import('../account-reset-form/account-reset-form.vue'),
  },
  props: {
    view: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      activeForm: 'login',
    };
  },
  mounted() {
    this.convertUrlIDtoQueryString();
    this.changeForm(this.view);

    if (window.localStorage.getItem('recover-left')) {
      this.activeForm = 'recover-alt';

      window.localStorage.removeItem('recover-left');
    }
  },
  methods: {
    convertUrlIDtoQueryString() {
      if (~location.href.indexOf('#recover')) {
        history.replaceState(null, null, `${location.pathname}?form=recover`);
      }
    },
    changeForm(form = false) {
      const parsed = qs.parse(location.search);
      if (!form && !parsed.form) {
        return;
      }
      if (!form) {
        form = parsed.form;
      } else {
        parsed.form = form;
      }
      this.activeForm = form;
      history.replaceState(
        null,
        null,
        `${location.pathname}?${qs.stringify(parsed)}`,
      );

      const getFormEvent = () => {
        switch (form) {
          case 'register':
            return 'sign_up_start';
          case 'recover':
            return 'password_forgot';
          default:
            return null;
        }
      };

      const formEvent = getFormEvent();
      if (form && formEvent) {
        const param = {
          event: formEvent,
        };
        pushDataSignup(param);
      }
    },
  },
};
